import { render, staticRenderFns } from "./InformationOverview.vue?vue&type=template&id=8ab78952&scoped=true&"
import script from "./InformationOverview.vue?vue&type=script&lang=ts&"
export * from "./InformationOverview.vue?vue&type=script&lang=ts&"
import style0 from "./InformationOverview.vue?vue&type=style&index=0&id=8ab78952&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab78952",
  null
  
)

export default component.exports